export default {
  document_upload_instructions: 'Por favor, envie uma cópia do Documento de Identidade para o seguite e-mail: <a href="mailto:meusdados@simplic.com.br">meusdados@simplic.com.br</a>',
};
